/**
 * la classe di modello della presenza
 */
import { Studente } from '../didattica/studente';
import { GruppoStudenti } from '../registro/gruppo-studenti';
import { AbscenceJustificationModel } from './absence.model';
import { ModalitaErogazione } from './rilevazione';

export interface Presenza {
  id: any;
  idRilevazione: any;
  rilevazione?: any;
  idStudente: any;
  matricola?: string;

  istanteMarcatura?: Date;
  istanteCancellazione?: Date;

  istanteUscita?: Date;

  stato: StatoPresenza;

  // luogo in cui la presenza è stato registrata
  latitudine?: number;
  longitudine?: number;

  studente?: Studente;
  ritardo?: boolean;
  giustificata?: boolean;

  // la durata della rilevazione collegata
  durata?: number;

  // l'operatore che ha aggiunto manualmente la presenza
  idOperatore?: any;

  modalitaFruizione?: ModalitaErogazione;

  autoreUltimaModifica?: string;

  istanteUltimaModifica?: Date;
  
  /**
   * Ritorna cognome e nome dello studente
   */
  descrizione?: () => string;

  // precentualeVerifica?: () => string;

  confermata?: () => any;

  // la verifica delle presenze da parte di un docente
  richiesteDiConferma?: number;

  // la conferma della presenza da parte di uno studente
  confermeDiPresenza?: number;

  confermaPresenza?: any;

  // usato solo nella visualizzazione dell'elenco dei presenti
  prenotato?: boolean;

  giustificazione?: AbscenceJustificationModel;

  visualizzaGruppiAppartenenza?: boolean;
  gruppiAppartenenza?: GruppoStudenti[];

  rilAccademica?: boolean;

  errorMessage?: string;

  flags?: PresenzaFlags
}

export interface PresenzaFlags {
    confermaPresenza: boolean;
    segnalareAbuso: boolean;
    resettareAbuso: boolean;
    segnalareAssenza: boolean;
    rimuovereAssenza: boolean;
    modificaPresenza: boolean;
    modificaPresenzaEnabled: boolean;
    rimuoverePresenza: boolean;
}
export interface PresenzaPageLabels {
    segnalareAssenza: boolean;
    rimuovereAssenza: boolean;
    segnalareAbuso: boolean;
    confermaPresenza: boolean;
    modificaPresenza: boolean;
    rimuoverePresenza: boolean;
}

export enum StatoPresenza {
  PRESENZA = <any>'PRESENZA',
  ABUSO = <any>'ABUSO',
  ASSENZA = <any>'ASSENZA'
}
